import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8424faba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mxa-title pb-2 pt-2",
  "data-test": "title"
}
const _hoisted_2 = { class: "mxa-content" }
const _hoisted_3 = { class: "mxa-area-content" }
const _hoisted_4 = { class: "col-12 col-md-8 col-xl-6" }
const _hoisted_5 = { class: "pb-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "username",
  autocomplete: "username",
  value: "",
  hidden: ""
}, null, -1))
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "pb-2" }
const _hoisted_9 = { class: "pb-2" }
const _hoisted_10 = { class: "pb-2" }

import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import BaseButton from '@/components/common/button/BaseButton.vue'
import BasePassword from '@/components/common/input/BasePassword.vue'
import BaseCheckbox from '@/components/common/input/BaseCheckbox.vue'
import ErrorMessage from '@/components/common/screen/ErrorMessage.vue'
import NormalMessage from '@/components/common/screen/NormalMessage.vue'
import * as log from '@/model/util/log/Logger'
import {
  usePassword,
  passwordUpdate,
  useErrorMsg,
  useNormalMsg,
  initDom,
} from '@/model/components/users/userPasswordUpdate'
import PasswordDesc from '@/components/common/screen/PasswordDesc.vue'


import { defineComponent, onMounted } from 'vue'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PasswordUpdate',
  setup(__props) {

log.trace(`PasswordUpdate setup start.`)

// 状態
const state = usePassword()
const store = useStore()
const router = useRouter()
const errorState = useErrorMsg()
const nomralState = useNormalMsg()

// onMountedの登録
onMounted(async () => {
  log.trace('PasswordUpdate onMounted start.')
  // 認証情報の設定
  // 認証切れの場合はTOP画面に遷移する
  await initDom(store, router)
  log.trace('PasswordUpdate onMounted end.')
})
/**
 * パスワード更新ボタンクリック
 */
const onClick = async () => {
  log.trace(`PasswordUpdate onClick start.`)
  // api送信の実施
  await passwordUpdate(state, store, router, errorState, nomralState)
  log.trace(`PasswordUpdate click end.`)
}
log.trace(`PasswordUpdate setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('body.menu.password.title')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(PasswordDesc, { type: false }),
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
            novalidate: ""
          }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(BasePassword, {
                    placeholder: _ctx.$t('body.main.edit.password.now.placeholder'),
                    modelValue: _unref(state).nowpassword,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).nowpassword) = $event)),
                    autocomplete: "current-password",
                    passwordStatus: !_unref(state).dispPassword,
                    "init-focus": true,
                    "data-test": "nowpassword"
                  }, null, 8, ["placeholder", "modelValue", "passwordStatus"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(BasePassword, {
                    placeholder: _ctx.$t('body.main.edit.password.new.placeholder'),
                    modelValue: _unref(state).newpassword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).newpassword) = $event)),
                    autocomplete: "new-password",
                    passwordStatus: !_unref(state).dispPassword,
                    "data-test": "newpassword"
                  }, null, 8, ["placeholder", "modelValue", "passwordStatus"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(BasePassword, {
                    placeholder: _ctx.$t('body.main.edit.password.newconfirm.placeholder'),
                    modelValue: _unref(state).newpasswordConfirm,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).newpasswordConfirm) = $event)),
                    autocomplete: "new-password",
                    passwordStatus: !_unref(state).dispPassword,
                    "data-test": "newpasswordConfirm"
                  }, null, 8, ["placeholder", "modelValue", "passwordStatus"])
                ])
              ]),
              _createVNode(BaseCheckbox, {
                modelValue: _unref(state).dispPassword,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).dispPassword) = $event)),
                label: _ctx.$t('body.common.passowrd.disp.passowrd'),
                domId: "passupdateCheck"
              }, null, 8, ["modelValue", "label"])
            ]),
            _createVNode(NormalMessage, { normal: _unref(nomralState) }, null, 8, ["normal"]),
            _createVNode(ErrorMessage, { error: _unref(errorState) }, null, 8, ["error"]),
            _createElementVNode("div", null, [
              _createVNode(BaseButton, {
                loading: _unref(state).loading,
                isDisabled: _unref(state).loading,
                label: _ctx.$t('body.main.edit.password.button.label'),
                onButtonClick: _cache[4] || (_cache[4] = ($event: any) => (onClick()))
              }, null, 8, ["loading", "isDisabled", "label"])
            ])
          ], 32)
        ])
      ])
    ])
  ], 64))
}
}

})